import videojs from "video.js";
import "./video-player.css";

const Slider = videojs.getComponent("Slider");
const handleMouseDown = Slider.prototype.handleMouseDown;

Slider.prototype.handleMouseDown = function(event) {
  // Video.js 7 uses passive touch listeners but still cancels touchstart for
  // non-Chrome user agents. CSS touch-action handles scrolling on these controls.
  if (event.type === "touchstart") {
    return handleMouseDown.call(this, { ...event, preventDefault() {} });
  }
  return handleMouseDown.call(this, event);
};

export default videojs;
